import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VAppBar, {
    ref: "toolbarContainer",
    staticClass: "core-toolbar",
    style: _vm.setTop,
    attrs: {
      "app": "",
      "flat": "",
      "id": "core-toolbar"
    }
  }, [_c('core-feedback', {
    attrs: {
      "feedbackDialog": _vm.feedbackDialog,
      "dialogTitle": _vm.dialogTitle,
      "type": _vm.dialogType
    },
    on: {
      "close": function ($event) {
        _vm.feedbackDialog = false;
      }
    }
  }), _c('div', [_c(VToolbarTitle, {
    staticClass: "breadcrumbs font-weight-light text-truncate",
    style: `max-width: ${_vm.breadcrumbsWidth}`
  }, [_vm.$vuetify.breakpoint.smAndDown ? _c(VBtn, {
    staticClass: "default v-btn--simple",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.onClickBtn.apply(null, arguments);
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("fal fa-bars")])], 1) : _vm._e(), _vm._l(_vm.breadcrumbsItems, function (item, i) {
    return _c('span', {
      key: `bc_${i}`
    }, [typeof item === 'string' || typeof item === 'number' ? _c('span', {
      domProps: {
        "innerHTML": _vm._s(item)
      }
    }) : item ? [item.to ? _c('router-link', {
      attrs: {
        "to": item.to
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    })]) : typeof item.click === 'function' ? _c('a', {
      on: {
        "click": function ($event) {
          return item.click();
        }
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    })]) : _c('a', {
      attrs: {
        "href": item.href
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    })])] : _vm._e(), _vm._v("\n        " + _vm._s(i < _vm.breadcrumbsItems.length - 1 ? '>' : '') + "\n      ")], 2);
  })], 2)], 1), _c(VSpacer), _c(VToolbarItems, [_c('span', {
    class: `overline mr-2 userEmail ${_vm.isImpersonating ? 'pl-2 pr-1 my-2 impersonatedEmail' : ''}`
  }, [_vm.$vuetify.breakpoint.smAndUp ? _c('span', [_vm._v(_vm._s(_vm.user.email))]) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.isImpersonating ? _vm.$i18n_t('accMgmt.tenant.isImpersonating') : '') + "\n      "), _vm.isImpersonating ? _c('core-button', {
    staticClass: "ml-2",
    attrs: {
      "color": "danger",
      "prepend-icon": "fa-undo",
      "solid-icon": "",
      "data-cy": "btn_impersonate_restore"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.onRestore.apply(null, arguments);
      }
    }
  }) : _vm._e()], 1), _vm.isFeatureFlagEnabled('rd-7759-iot-shop') ? _c('core-button', {
    staticClass: "mr-2",
    attrs: {
      "color": _vm.color,
      "solid-icon": "",
      "prepend-icon": "fa-store-alt",
      "href": _vm.shopLink,
      "target": "_blank"
    }
  }) : _vm._e(), !_vm.isMobile ? _c('span', [_vm.showTicketNotificationBell ? _c(VBtn, {
    class: 'mr-2 v-btn-x v-btn--rounded bg-rounded-button-' + _vm.color,
    attrs: {
      "icon": "",
      "rounded": "",
      "to": "/fm-ticketing-mgmt"
    }
  }, [_c(VBadge, {
    attrs: {
      "overlap": "",
      "color": "danger"
    },
    scopedSlots: _vm._u([{
      key: "badge",
      fn: function () {
        return [_vm._v(_vm._s(_vm.newTicketCount))];
      },
      proxy: true
    }], null, false, 3694217774)
  }, [_c(VIcon, {
    attrs: {
      "color": _vm.color
    }
  }, [_vm._v("fas fa-bell")])], 1)], 1) : _vm._e(), _vm.canCreateTickets && (_vm.$vuetify.breakpoint.mdAndUp || !_vm.showTicketNotificationBell) ? _c('core-button', {
    staticClass: "mr-2",
    attrs: {
      "title": _vm.$i18n_t('Common.drawer.fmTicketsAdd'),
      "color": _vm.color,
      "solid-icon": "",
      "prepend-icon": "fa-file-plus",
      "to": "/fm-add-ticket"
    }
  }) : _vm._e(), _c('core-filter', {
    attrs: {
      "userT": _vm.userT
    }
  }), _vm.canScheduleExports ? [_c('core-button', {
    staticClass: "mr-2",
    attrs: {
      "title": _vm.$i18n_t('Core.Toolbar.exportsScheduleBtn'),
      "color": _vm.color,
      "prepend-icon": "fa-calendar-alt",
      "solid-icon": "",
      "to": "/scheduled-exports"
    }
  })] : _vm._e(), _c('core-help', {
    attrs: {
      "manualPath": _vm.getPath(_vm.$route.meta)
    },
    on: {
      "open-dialog": _vm.openDialog
    }
  }), _c('core-button', {
    attrs: {
      "data-cy": "btn_logout",
      "title": _vm.$i18n_t('Core.Toolbar.logoutBtn'),
      "color": _vm.color,
      "prepend-icon": "fa-sign-out",
      "solid-icon": ""
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.onLogout.apply(null, arguments);
      }
    }
  })], 2) : _c('core-toolbar-menu', {
    attrs: {
      "canCreateTickets": _vm.canCreateTickets,
      "newTicketCount": _vm.newTicketCount,
      "showTicketNotificationBell": _vm.showTicketNotificationBell
    },
    on: {
      "logout": _vm.onLogout
    }
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };